import {ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts'
import {useEffect, useMemo, useState} from 'react'
import moment from 'moment'
import PageLayout from '../../components/layout/PageLayout'
import WizSelect from '../../components/select/WizSelect'
import {useQueryAppInstall} from '../../hooks/api/analysis/useQueryAppInstall'

interface IProps {
    className?: string
}

const AppInstallDashBoard: React.FC<IProps> = () => {
    const [limit, setLimit] = useState(100)
    const [hideExchange, setHide] = useState({})
    const {data, refetch} = useQueryAppInstall(limit)
    let rgbColors = [
        'rgb(251, 206, 177)',
        'rgb(219, 112, 147)',
        'rgb(255, 68, 51)',
        'rgb(244, 180, 0)',
        'rgb(248, 108, 108)',
        'rgb(50, 23, 77)',
        'rgb(50, 74, 178)',
        'rgb(72, 60, 50)',
        'rgb(0, 73, 88)',
        'rgb(0, 144, 0)',
    ]

    const charts = useMemo(() => {
        if (data === undefined) {
            return []
        }

        return data.map(el => {
            return {
                ...el,
                date: moment.utc(el.date, 'YYYYMMDD').local().format('YYYY/MM/DD'),
            }
        })
    }, [data, limit])

    useEffect(() => {
        refetch()
    }, [data, limit])

    return (
        <PageLayout title="Lot App install count">
            <div className={'flex space-x-[10px]'}>
                <WizSelect optionKey={'graph_limit'} value={limit} onChange={e => setLimit(e as number)} />
            </div>
            <ResponsiveContainer width="100%" height={700}>
                <ComposedChart data={charts} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                    <XAxis dataKey="date" />
                    <YAxis orientation="left" />
                    <YAxis orientation="right" yAxisId={'android'} />
                    <Legend
                        onClick={e => {
                            setHide({
                                ...hideExchange,
                                [String(e.dataKey)]: !hideExchange[String(e.dataKey)],
                            })
                        }}
                    />
                    <Tooltip />
                    <Line
                        dot={<div></div>}
                        type="monotone"
                        dataKey={'ios'}
                        stroke={rgbColors[0]}
                        strokeWidth={1}
                        activeDot={{r: 3}}
                    />
                    <Line
                        dot={<div></div>}
                        type="monotone"
                        yAxisId={'android'}
                        dataKey={'android'}
                        stroke={rgbColors[3]}
                        strokeWidth={1}
                        activeDot={{r: 3}}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </PageLayout>
    )
}

export default AppInstallDashBoard
